import moment from 'moment-timezone'

/**
 * Agendamentos Mensageria ficam em GMT-0 no servidor.
 * Exibe no fuso local do navegador (ex.: America/Bahia = UTC-3).
 * Não altera o valor armazenado na API.
 *
 * @param {string|Date|number} date
 * @param {string} [format='DD/MM/YYYY HH:mm']
 * @returns {string}
 */
export function formatServerUtcToLocal(date, format = 'DD/MM/YYYY HH:mm') {
  if (date == null || date === '') return '—'
  const m = moment.utc(date)
  if (!m.isValid()) return String(date)
  return m.local().format(format)
}

/**
 * Converte hora UTC 0–23 (ex.: HOUR(send_date) no MySQL GMT-0)
 * para a hora local do viewer.
 *
 * @param {number|string} utcHour
 * @returns {number} 0–23
 */
export function utcHourToLocalHour(utcHour) {
  const h = Number(utcHour)
  if (!Number.isFinite(h) || h < 0 || h > 23) return 0
  const offsetHours = moment().utcOffset() / 60
  return (((h + offsetHours) % 24) + 24) % 24
}
